module.exports = __webpack_public_path__ + "static/media/traffic-moderate.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/traffic-moderate.svg
// module id = 695
// module chunks = 0